import { render, staticRenderFns } from "./AlertWraper.vue?vue&type=template&id=6bb3ee30"
import script from "./AlertWraper.vue?vue&type=script&lang=js"
export * from "./AlertWraper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports